"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class HiddenInputs extends _react.default.Component {
  constructor(props) {
    super(props);
    this.createHiddenInput = this.createHiddenInput.bind(this);
  }
  createHiddenInput(key) {
    const {
      inputs
    } = this.props;
    const value = inputs[key];
    if (value === false) return null;
    return /*#__PURE__*/_react.default.createElement("input", {
      key: key,
      type: "hidden",
      value: value,
      name: key
    });
  }
  render() {
    const {
      inputs
    } = this.props;
    const html = Object.keys(inputs).map(this.createHiddenInput);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "generatedHiddenInputs"
    }, html);
  }
}
HiddenInputs.propTypes = {
  inputs: _propTypes.object
};
var _default = exports.default = HiddenInputs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/hiddenInputs.js
// module id = 402
// module chunks = 119